function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "backgroundrect",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0,
  fill: "none",
  stroke: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Layer 1");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#BE1E2D",
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
  id: "svg_1",
  className: "",
  fillOpacity: 1
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M52.747253224089775,52.747253224089775 h-28.747253224089775 v-28.747253224089775 H52.747253224089775 z",
  fill: "none",
  id: "svg_2",
  className: ""
});

var SvgTimes = function SvgTimes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    style: {},
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _ref3, _ref4, _ref5));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/times.a56528a5.svg";
export { ForwardRef as ReactComponent };